var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 512 512",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m472.794 128.079 21.213-21.213-106.866-106.866-21.213 21.213 21.613 21.613-24.385 24.385c-4.994-.625-10.078-.698-15.155-.247v-40.957h-330.001v450h60v36h330v-321.112c14.461-16.986 21.394-39.281 18.795-60.044l24.385-24.385zm-424.794 317.928v-390h270v19.921c-5.264 2.777-10.272 6.149-14.888 10.079h-126.325l-98.787 98.786v261.213h-30zm120-308.787v38.787h-38.787zm-60 344.787v-276h90v-90h104.737l27.025 27.025-48.287 48.287 21.213 21.213 48.288-48.288 27.024 27.026v290.737zm285.854-360.641c.409 4.04 8.944 19.562-2.444 40.887l-59.657-59.657c21.449-11.452 36.651-2.872 40.887-2.443l36.114-36.114 21.213 21.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183 319.793-19.393-19.393-21.213 21.213 40.606 40.607 70.607-70.607-21.213-21.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183 409.793-19.393-19.393-21.213 21.213 40.606 40.607 70.607-70.607-21.213-21.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 296.007h60v30h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 386.007h60v30h-60z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.839dba0b17484900e03ea8a4160b984c.svg";
export { ForwardRef as ReactComponent };